import styled from "styled-components";

export const Container = styled.div`
  height: 100%;
  overflow-y: auto;
  padding: 24px 28px;
`;

export const ErrorState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 56px 20px;
  text-align: center;
  font-size: 14px;
  color: ${(props) => props.theme.brand.muted};
`;

export const RetryButton = styled.button`
  border: 1px solid ${(props) => props.theme.brand.line};
  background: transparent;
  color: ${(props) => props.theme.brand.navy};
  font-size: 13px;
  font-weight: 600;
  padding: 9px 18px;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background: #f5f8fb;
  }
`;
